import { render, staticRenderFns } from "./ordersAdd.vue?vue&type=template&id=61731fac&scoped=true&"
import script from "./ordersAdd.vue?vue&type=script&lang=js&"
export * from "./ordersAdd.vue?vue&type=script&lang=js&"
import style0 from "./ordersAdd.vue?vue&type=style&index=0&id=61731fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61731fac",
  null
  
)

export default component.exports